
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { DevAuthService } from './dev-auth.service';
import { map, pluck} from 'rxjs';

export const devWebsite: CanActivateFn = (route: ActivatedRouteSnapshot,  state: RouterStateSnapshot) => {
  const router = inject(Router);
  const devAuthService = inject(DevAuthService);
  const pass = localStorage.getItem('devPass');
  if (pass === null) {
    return router.createUrlTree(['/login']); 
  } 
  return devAuthService.verifyPass(pass).pipe(pluck('success'), map((success) => {
    if (!success) {
      return router.createUrlTree(['/login']);
    }
    return success;
  }));
}

